import type { JSX } from 'react';
import { Button } from './Button';

interface Tab {
  id: string;
  label: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  className?: string;
}

export function Tabs({ tabs, activeTab, onTabChange, className = '' }: TabsProps): JSX.Element {
  return (
    <div className={`flex border-b border-gray-200 ${className}`}>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <Button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            variant="ghost"
            className={`flex-1 py-3 text-sm font-medium border-b-2 transition-colors rounded-none ${
              isActive
                ? 'border-b-primary text-primary'
                : 'border-b-transparent text-gray-500'
            }`}
          >
            {tab.label}
          </Button>
        );
      })}
    </div>
  );
}
